import React from 'react';
import PropTypes from 'prop-types';
import { PreferenceActionBox } from './components/preference-action-box';
import { ActivityList } from './components/activity-list';
import { translate } from '@td/shared_utils';
import { WithNotifications, WithPubnub, WithQueryProvider } from '@teladoc/inbox';

const locales = {
  headerTitle:        translate(null, 'notification_preferences', 'header_title'),
  submitButton:       translate(null, 'notification_preferences', 'submit_button'),
  activityListTitle:  translate(null, 'notification_preferences', 'activity_list_title'),
  toolTipContent:     translate(null, 'notification_preferences', 'browser_checkbox_tooltip_content'),
  emptyActivityTitle: translate(null, 'notification_preferences', 'empty_activity_text')
};

const pubnubEnabled = window.FEATURE_TOGGLES.pubnub_live_chat;

const PreferencePage = ({ notificationList }) =>
   (
     <section className="preference-wrapper">
       <header>
         <p>{locales.headerTitle}</p>
       </header>
       <main className="content-wrapper">
         <PreferenceActionBox
           locales={locales}
         />
         <ActivityList
           notificationList={notificationList}
           locales={locales}
         />
       </main>
     </section>
  );

PreferencePage.propTypes = {
  notificationList:       PropTypes.array,
  getListOfNotifications: PropTypes.object,
  notificationEvent:      PropTypes.object
};

export default pubnubEnabled
  ? WithQueryProvider(WithPubnub(WithNotifications(PreferencePage, true)))
  : WithQueryProvider(WithNotifications(PreferencePage, true));
